import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNewspaper3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"newspaper-3"} maskId="square-filled-radius-0-stroke-1-IconNewspaper3"><path fillRule="evenodd" clipRule="evenodd" d="M2 4H22V20H2V4ZM12 8H19V9H12V8ZM12 11.5H19V12.5H12V11.5ZM5 15H19V16H5V15ZM5 8V12.5H6V9.25073L8.90113 12.5H10V8H9V11.1093L6.22387 8H5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconNewspaper3;
